import { createUseQuery } from 'api/common/createUseQuery'
import { fetchFiles } from 'api/fetchers/fetchFiles'

export const useFiles = (year: number = 2025) =>
  createUseQuery({
    queryKey: ['AWARDS_FILES', year.toString()],
    fetcher: () => fetchFiles(year),
    selector: res => res?.data ?? [],
    keepPreviousData: true,
  })
